import script from "./colldevice.vue?vue&type=script&lang=ts&setup=true"
export * from "./colldevice.vue?vue&type=script&lang=ts&setup=true"

import "./colldevice.vue?vue&type=style&index=0&id=bade2e48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bade2e48"]])

export default __exports__